import React, { useState, useEffect } from 'react'
import { API, Auth } from 'aws-amplify';
import "@aws-amplify/ui-react/styles.css";
import "react-datepicker/dist/react-datepicker.css";
import Loadingmini from '../components/loadingmini';
import { Flex, View, Text, Button, Heading, SelectField} from '@aws-amplify/ui-react';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { NavLink, useLocation} from "react-router-dom";
import { getPortalSession } from '../auth/portalSession';

export default function Bulkuploads() {
  const roundBack = (date,hours) => {
    date.setHours(date.getHours() - hours);
    date.setMinutes(0, 0, 0);
    return date;
  }
  const [is_loading, updateIsLoading] = React.useState(false);
  const location = useLocation();
  const [selected_fleet, updateSelectedFleet] = React.useState([]);
  const [myerror, updateMyError] = React.useState(false);
  const [mysuccess, updateMySuccess] = React.useState(false);
  const [myloading, updateMyloading] = React.useState(false);
	const [selectedFile, setSelectedFile] = useState(undefined);
  const [presigned_url_drivers, updatePresignedUrlDrivers] = React.useState("");
  const [presigned_url_schedule, updatePresignedUrlSchedule] = React.useState("");
  const [new_document_name_drivers, updateNewDocumentNameDrivers] = React.useState("");
  const [new_document_name_schedule, updateNewDocumentNameSchedule] = React.useState("");
	const [isSelected, setIsSelected] = useState(false);
	const [showEnterDriversManually, updateShowEnterDriversManually] = useState(false);
	const [showEnterScheduleManually, updateShowEnterScheduleManually] = useState(false);
	const [showUploadDriversFile, updateShowUploadDriversFile] = useState(false);
	const [showUploadScheduleFile, updateShowUploadScheduleFile] = useState(false);
	const [showDriverOptions, updateShowDriverOptions] = useState(false);
	const [showScheduleOptions, updateShowScheduleOptions] = useState(false);
	const [schedule_year, updateScheduleYear] = useState("2023");
	const [schedule_month, updateScheduleMonth] = useState("");
  const [manualDrivers, setManualDrivers] = useState([{ first_name: '', last_name: '', license_number: '', license_state: '', email: '', phone_number: '', date_of_birth: '', run_mvr: 'no', policy_id: '' }]);
  const [manualSchedule, setManualSchedule] = useState([{ vin: '', licenseNumber: '', licenseState: '', driverName: '', driverLicense: '', driverLicenseState: '', driverEmail: '', resStart: '', resEnd: '' }]);
  const [available_insurance_policies, updateAvailableInsurancePolicies] = React.useState([]);
  const [startDate, updateStartDate] = useState(roundBack(new Date(),12));
  const [endDate, updateEndDate] = useState(roundBack(new Date(),16));
  const [bulkUserAddResults, updateBulkUserAddResults] = useState({"users":[{"first_name":"","last_name":"","license_number":"","action":"","input_errors":""}]});
  const [showBulkUploadUserResults, updateShowBulkUploadUserResults] = React.useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const fleetsParam = params.get("fleets");
    if (fleetsParam) {
        updateSelectedFleet(fleetsParam.split(","));
    } else {
        updateSelectedFleet([]);
    }
  }, [location.search]);

  const handleScheduleChange = (index, field, value) => {
    const updatedSchedule = [...manualSchedule];
    updatedSchedule[index][field] = value;
    setManualSchedule(updatedSchedule);
  };

  const addScheduleRow = () => {
    setManualSchedule([
      ...manualSchedule,
      { vin: '', licenseNumber: '', licenseState: '', driverName: '', driverLicense: '', driverLicenseState: '', driverEmail: '', resStart: '', resEnd: '' }
    ]);
  };

  const removeScheduleRow = (index) => {
    const updatedDrivers = manualDrivers.filter((_, i) => i !== index);
    setManualDrivers(updatedDrivers);
  };

  const handleDriverChange = (index, field, value) => {
    const updatedDrivers = [...manualDrivers];
    updatedDrivers[index][field] = value;
    setManualDrivers(updatedDrivers);
  };

  const addDriverRow = () => {
    setManualDrivers([
      ...manualDrivers,
      { first_name: '', last_name: '', license_number: '', license_state: '', email: '', phone_number: '', date_of_birth: '', run_mvr: 'no', policy_id: '' }
    ]);
  };

  const removeDriverRow = (index) => {
    const updatedDrivers = manualDrivers.filter((_, i) => i !== index);
    setManualDrivers(updatedDrivers);
  };

  async function selectNewFleet(val)
  {
      updateSelectedFleet(val)
      resetPage()
  }

  async function resetPage()
  {
    setIsSelected(false)
    setSelectedFile(undefined)
    updateShowEnterDriversManually(false)
    updateShowEnterScheduleManually(false)
    updateShowUploadDriversFile(false)
    updateShowUploadScheduleFile(false)
    updateShowDriverOptions(false)
    updateShowScheduleOptions(false)
    updateMySuccess(false)
    updateMyError(false)
    updateShowBulkUploadUserResults(false)
    updateMyloading(false)
  }

  async function getUserFleets() {
    updateIsLoading(true)
    try {
        var res = await getPortalSession()
    }
    catch (e) {
        var thisError = "Error retrieving fleets - email us at developer@agorisk.com: "+toString(e)
        updateMyError(thisError)
        updateIsLoading(false)
        return;
    }
    var selectedFleet = (Array.isArray(res['fleet_codes']) && res['fleet_codes'].length > 0) 
        ? res['fleet_codes'][0] 
        : null;
    if (selectedFleet) {
        updateSelectedFleet(selectedFleet);
        //console.log('fleet selected: '+selectedFleet)
    }
    updateAvailableInsurancePolicies(res.insurance_policies)
    updateIsLoading(false)
  }

  useEffect(() => {
    getUserFleets()
  },[])


  async function submitFile(docType) {
    updateIsLoading(true);
    updateMyloading(true);
    if(!isSelected)
    {
      console.log('no document selected')
      updateMyError("Please select a file before submitting.")
      updateIsLoading(false);
      return;
    }
    let session = await Auth.currentSession() 
    if(docType=='drivers')
    {
      await fetch(presigned_url_drivers, {
          method:'PUT',
          body:selectedFile,
          headers: {
              'Access-Control-Allow-Headers': '*',
              'Access-Control-Allow-Origin': '*'
          }
      }).then((res) => {
          let accessToken = session.getAccessToken()
          let jwt = accessToken.getJwtToken()
          const myInit = {queryStringParameters:{ 
              back_end: process.env.REACT_APP_BACKEND, 
              jwt:jwt, 
              api_endpoint: "api3:staff:driver_bulk",
              document_name: new_document_name_drivers,
              fleet_code: selected_fleet[0]
          }};
          console.log('myInit: '+JSON.stringify(myInit))
          console.log('doc name drivers:'+new_document_name_drivers)
          try {
              API.get('adminWebTools','/ago',myInit).then((res3) => {
                  console.log(JSON.stringify(res3))
                  updateBulkUserAddResults(res3)
                  updateShowBulkUploadUserResults(true)
              });
          } catch (e) {
              var statusString = "Error uploading file: " + e;
              updateMyError(statusString);
          }
      })
    } else {
      if(schedule_month!=='')
        {
          await fetch(presigned_url_schedule, {
              method:'PUT',
              body:selectedFile,
              headers: {
                  'Access-Control-Allow-Headers': '*',
                  'Access-Control-Allow-Origin': '*'
              }
          }).then((res) => {
              let accessToken = session.getAccessToken()
              let jwt = accessToken.getJwtToken()
              var yearMonth = schedule_year + "-" + schedule_month;
              const myInit = {queryStringParameters:{ 
                  back_end: process.env.REACT_APP_BACKEND, 
                  jwt:jwt, document_name: new_document_name_schedule, 
                  "api_endpoint": "api3:staff:schedule_upload",
                  schedule_yyyy_mm:yearMonth
              }};
              console.log('doc name schedule: '+new_document_name_schedule)
              try {
                  API.get('adminWebTools','/ago',myInit).then((res3) => {
                    console.log(JSON.stringify(res3))
                    updateMySuccess(true)
                  });
              } catch (e) {
                var statusString = "Error uploading file: " + e;
                updateMyError(statusString);
              }
          })
      } else {
          //  MUST UPLOAD A FILE
          var statusString = "Please select a file for upload before submitting";
          updateMyError(statusString);
      }
    }
    updateIsLoading(false);
  }

	const updateFile = (event) => {
		setSelectedFile(event.target.files[0]);
		setIsSelected(true);
	};

  async function submitManualSchedule()
  {
    updateIsLoading(true)


    /*
    let session = await Auth.currentSession()      
    let accessToken = session.getAccessToken()
    let jwt = accessToken.getJwtToken()
    const myInit = {queryStringParameters:{
        back_end: process.env.REACT_APP_BACKEND, 
        jwt:jwt,
        api_endpoint: "api3:staff:driver_bulk",
        fleet_code:selected_fleet,
        manual_drivers:manualDrivers
    }};
    console.log(JSON.stringify(myInit))
    try {
        const res = await API.get('adminWebTools','/ago',myInit)
        console.log(JSON.stringify(res))
    }
    catch (e) {
        const res = {status:"Error: " + JSON.stringify(e)}
        updateMyError(res)
    }
    */
    updateIsLoading(false)
  }

  async function submitManualDrivers()
  {
    updateIsLoading(true)
    const payload = manualDrivers.map(driver => ({
        ...driver,
        date_of_birth: new Date(driver.date_of_birth).toISOString().split('T')[0]
        //date_of_birth: Date(driver.date_of_birth + "00:00:00")
        //policy_id: Number(driver.policy_id), // ensure policy_id is a number
    }))
    let session = await Auth.currentSession()      
    let accessToken = session.getAccessToken()
    let jwt = accessToken.getJwtToken()
    const myInit = {
      headers: {
        'Content-Type': 'application/json'
      },
      body: {users:payload},
      queryStringParameters:{
        back_end: process.env.REACT_APP_BACKEND, 
        jwt:jwt,
        api_endpoint: "api3:staff:add_users",
        fleet:selected_fleet[0]
    }};
    //console.log(JSON.stringify(manualDrivers))
    //console.log(JSON.stringify(myInit))
    try {
        const res = await API.post('adminWebTools','/ago',myInit)
        updateBulkUserAddResults(res)
        updateShowBulkUploadUserResults(true)
        
        console.log(JSON.stringify(res))
    }
    catch (e) {
        updateMyError("Error: " + JSON.stringify(e))
    }
    updateIsLoading(false)
  }


  async function getPresignedUrlDrivers() {
    updateIsLoading(true)
    let session = await Auth.currentSession()      
    let accessToken = session.getAccessToken()
    let jwt = accessToken.getJwtToken()
    const myInit = {queryStringParameters:{
        back_end: process.env.REACT_APP_BACKEND, 
        jwt:jwt,
        api_endpoint: "api3:staff:driver_bulk",
        fleet_code:selected_fleet[0],
        request_type:"GET"
    }};
    try {
        const res = await API.get('adminWebTools','/ago',myInit)
        console.log(JSON.stringify(res))
        updatePresignedUrlDrivers(res["presigned_url_upload"]);
        updateNewDocumentNameDrivers(res["new_document_name"]);
    }
    catch (e) {
        updateMyError("Error: " + JSON.stringify(e))
    }
    updateIsLoading(false)
  }

  async function getPresignedUrlSchedule() {
    updateIsLoading(true)
    let session = await Auth.currentSession()      
    let accessToken = session.getAccessToken()
    let jwt = accessToken.getJwtToken()
    const myInit = {queryStringParameters:{
        back_end: process.env.REACT_APP_BACKEND, 
        jwt:jwt,
        api_endpoint: "api3:staff:schedule_upload"
    }};
    try {
        const res = await API.get('adminWebTools','/ago',myInit)
        console.log(JSON.stringify(res))
        updatePresignedUrlSchedule(res["new_presigned_url"]);
        updateNewDocumentNameSchedule(res["new_document_name"]);
    }
    catch (e) {
        updateMyError("Error: " + JSON.stringify(e))
    }
    updateIsLoading(false)
  }

  async function showUploadBulkDrivers()
  {
    await getPresignedUrlDrivers();
    updateShowUploadDriversFile(true);
  }

  async function showUploadBulkSchedule()
  {
    await getPresignedUrlSchedule();
    updateShowUploadScheduleFile(true);
  }

  function handleUpdateScheduleMonth(value)
  {
      console.log(value);
      updateScheduleMonth(value);
  }

  function handleUpdateScheduleYear(value)
  {
      console.log(value);
      updateScheduleYear(value);
  }

  const _renderBulkUploadUserResults = () => {
    if(!bulkUserAddResults){
      return;
    }
    if(!bulkUserAddResults["users"]){
      return;
    }
    if(!Array.isArray(bulkUserAddResults["users"])){
      return;
    }
    if(!bulkUserAddResults["users"]){
      return;
    }
    return bulkUserAddResults["users"].map(function(object, index){
      return(<tr>
        <td style={{padding:'5px', paddingLeft:'20px', border:'1px solid black'}}>{object['first_name']}</td>
        <td style={{padding:'5px', paddingLeft:'20px', border:'1px solid black'}}>{object['last_name']}</td>
        <td style={{padding:'5px', paddingLeft:'20px', border:'1px solid black'}}>{object['license_number']}</td>
        <td style={{padding:'5px', paddingLeft:'20px', border:'1px solid black'}}>{object['action']}</td>
        <td style={{padding:'5px', paddingLeft:'20px', border:'1px solid black'}}>{JSON.stringify(object['input_errors'])}</td>
      </tr>)
    })
  }

  return (
    is_loading ? <Loadingmini /> : 
      <Flex
        direction="column"
      >
        <View style={{width:"100%"}}>
          <Flex direction="column" gap="1rem" >
            <Flex direction="column">
              <Heading level={2}>Bulk Uploads</Heading>
                { myerror ? <View>
                          <Heading level={4}>Whoops!</Heading>
                          <Text>We ran into an error processing your request:</Text>
                          <Text>{myerror}</Text>
                          <Text>Please refresh and try again.</Text>
                          <Button onClick={() => resetPage()}>EXIT</Button>
                    </View>
                  : showBulkUploadUserResults ? <View>
                    <Heading level={4}>Driver Upload Results</Heading>
                    <table>
                      <tr>
                        <th style={{padding:'5px', paddingLeft:'20px', border:'1px solid black'}}>First Name</th>
                        <th style={{padding:'5px', paddingLeft:'20px', border:'1px solid black'}}>Last Name</th>
                        <th style={{padding:'5px', paddingLeft:'20px', border:'1px solid black'}}>License Number</th>
                        <th style={{padding:'5px', paddingLeft:'20px', border:'1px solid black'}}>Action</th>
                        <th style={{padding:'5px', paddingLeft:'20px', border:'1px solid black'}}>Input Errors</th>
                      </tr>{_renderBulkUploadUserResults()}</table>
                    <br/>
                    <Button onClick={() => resetPage()}>EXIT</Button>
                  </View>
                  : mysuccess ? <View>
                          <Heading level={4}>Success!</Heading>
                          <Text>Your file has been uploaded.</Text>
                          <Button onClick={() => resetPage()}>EXIT</Button>
                    </View>
                  : myloading ? <View>
                          <Heading level={4}>Upload in Progress</Heading>
                          <Text>Your file is being uploaded...</Text>
                    </View>
                  : showUploadDriversFile ?
                    <View>
                      <Heading level={4}>Upload Bulk Drivers</Heading>
                      <br/>
                      <Text><a href='https://ago-misc-public-photos.s3.us-east-2.amazonaws.com/driverbulkupload.xlsx' target='_blank'>CLICK HERE</a> to download the example csv. Please do not change the columns if possible.</Text>
                      <br/>
                      <input type="file" name="file" onChange={updateFile} accept=".xlsx,.xls,.csv" />
                      {isSelected ? (
                        <View style={{padding:'5px', backgroundColor:'#e6ebf2'}}>
                          <Text>Filename: {selectedFile.name}</Text>
                          <Text>Filetype: {selectedFile.type}</Text>
                          <Text>Size in bytes: {selectedFile.size}</Text>
                          <Text>
                            lastModifiedDate:{' '}
                            {selectedFile.lastModifiedDate.toLocaleDateString()}
                          </Text>
                        </View>
                      ) : (
                        <View style={{padding:'5px', backgroundColor:'#e6ebf2'}}><Text>Select a file to show details</Text></View>
                      )}
                      <br />
                      <Button onClick={() => submitFile("drivers")}>SUBMIT</Button>
                      <br />
                      <br />
                      <Button onClick={() => resetPage()}>CANCEL</Button>
                    </View>
                  : showUploadScheduleFile ?
                    <View>
                      <Heading level={4}>Upload Bulk Schedule</Heading>
                      <br/>
                      <Text><a href='https://ago-misc-public-photos.s3.us-east-2.amazonaws.com/fleetScheduleUpload.xlsx' target='_blank'>CLICK HERE</a> to download the example csv. Please do not change the columns if possible.</Text>
                      <br/>
                      <Heading level={4}>What year and month is this data for?</Heading>
                      <table>
                          <tr>
                              <td style={{padding:'10px'}}>Year:</td>
                              <td style={{padding:'10px'}}><select name='schedule_year' onChange={(event) => handleUpdateScheduleYear(event.target.value)} defaultValue='2023'>
                                  <option value='2025'>2027</option>
                                  <option value='2025'>2026</option>
                                  <option value='2025'>2025</option>
                                  <option value='2024'>2024</option>
                                  <option value='2023'>2023</option>
                                  <option value='2022'>2022</option>
                              </select></td>
                          </tr>
                          <tr>
                              <td style={{padding:'10px'}}>Month:</td>
                              <td style={{padding:'10px'}}><select name='schedule_month' onChange={(event) => handleUpdateScheduleMonth(event.target.value)}>
                                  <option value=''>-PLEASE SELECT-</option>
                                  <option value='01'>January</option>
                                  <option value='02'>February</option>
                                  <option value='03'>March</option>
                                  <option value='04'>April</option>
                                  <option value='05'>May</option>
                                  <option value='06'>June</option>
                                  <option value='07'>July</option>
                                  <option value='08'>August</option>
                                  <option value='09'>September</option>
                                  <option value='10'>October</option>
                                  <option value='11'>November</option>
                                  <option value='12'>December</option>
                              </select></td>
                          </tr>
                      </table><br/>
                      <Heading level={4}>Select the file to upload</Heading>
                      <input type="file" name="file" onChange={updateFile} accept=".xlsx" />
 
                      
                      
                      {isSelected ? (
                        <View style={{padding:'5px', backgroundColor:'#e6ebf2'}}>
                          <Text>Filename: {selectedFile.name}</Text>
                          <Text>Filetype: {selectedFile.type}</Text>
                          <Text>Size in bytes: {selectedFile.size}</Text>
                          <Text>
                            lastModifiedDate:{' '}
                            {selectedFile.lastModifiedDate.toLocaleDateString()}
                          </Text>
                        </View>
                      ) : (
                        <View style={{padding:'5px', backgroundColor:'#e6ebf2'}}><Text>Select a file to show details</Text></View>
                      )}
                      <br />
                      <Button onClick={() => submitFile("schedule")}>SUBMIT</Button>
                      <br />
                      <br />
                      <Button onClick={() => resetPage()}>CANCEL</Button>
                    </View>
                  : showEnterDriversManually ? 
                    <View>
                      <Heading level={4}>Manually Add Drivers</Heading>
                      {manualDrivers.map((driver, index) => (
                        <View key={index} style={{ borderBottom: "1px solid #ccc", marginBottom: "1rem", paddingBottom: "1rem" }}>
                          <Text>Driver #{index + 1}</Text>
                          <input
                            type="text"
                            placeholder="First Name"
                            value={driver.first_name}
                            onChange={(e) => handleDriverChange(index, 'first_name', e.target.value)}
                            style={{ marginRight: "10px" }}
                          />
                          <input
                            type="text"
                            placeholder="Last Name"
                            value={driver.last_name}
                            onChange={(e) => handleDriverChange(index, 'last_name', e.target.value)}
                            style={{ marginRight: "10px" }}
                          />
                          <input
                            type="text"
                            placeholder="License Number"
                            value={driver.license_number}
                            onChange={(e) => handleDriverChange(index, 'license_number', e.target.value)}
                            style={{ marginRight: "10px" }}
                          />
                          <input
                            type="text"
                            placeholder="License State"
                            value={driver.license_state}
                            onChange={(e) => handleDriverChange(index, 'license_state', e.target.value)}
                            style={{ marginRight: "10px" }}
                          />
                          <input
                            type="email"
                            placeholder="Email"
                            value={driver.email}
                            onChange={(e) => handleDriverChange(index, 'email', e.target.value)}
                            style={{ marginRight: "10px" }}
                          />
                          <input
                            type="tel"
                            placeholder="Phone Number"
                            value={driver.phone_number}
                            onChange={(e) => handleDriverChange(index, 'phone_number', e.target.value)}
                            style={{ marginRight: "10px" }}
                          />
                          <br/>
                          <br/>
                          <SelectField
                            label="Insurance Policy"
                            value={driver.policy_id}
                            onChange={(e) => handleDriverChange(index, 'policy_id', e.target.value)}
                            style={{ maxWidth: '300px', marginRight: "10px" }}
                          >
                            <option value="">Select a policy</option>
                            {available_insurance_policies.length < 1 ? undefined : available_insurance_policies.map(policy => (
                              <option key={policy.id} value={policy.id}>
                                {policy.policy_number} - {policy.insuring_company_name}
                              </option>
                            ))}
                          </SelectField>
                        <br/>
                        <Flex direction="row" wrap="wrap" justifyContent="flex-start" gap="1rem">
                          <Text>Date of Birth:</Text>
                          <DatePicker
                                name="Date of Birth"
                                selected={driver.date_of_birth}
                                onChange={(date) => handleDriverChange(index, 'date_of_birth', date)}
                                showTimeSelect={false}
                                dateFormat="yyyy-MM-dd"
                                timeIntervals={60}
                              />
                        </Flex>
                        <br/>
                        <Text>Run an MVR? (This will incur a cost)</Text>
                        <select name='run_mvr' onChange={(event) => handleDriverChange(index, 'run_mvr', event.target.value)} defaultValue='no'>
                                  <option value='no'>no</option>
                                  <option value='yes'>yes</option>
                        </select>
                  
                          {manualDrivers.length > 1 && (
                            <Button variation="link" onClick={() => removeDriverRow(index)}>Remove</Button>
                          )}
                        </View>
                      ))}
                      <Button onClick={addDriverRow}>+ Add Another Driver</Button>
                      <br /><br />
                      <Button onClick={submitManualDrivers}>SUBMIT</Button>
                      <br /><br />
                      <Button onClick={() => resetPage()}>CANCEL</Button>
                    </View>
                  : showEnterScheduleManually ? 
                  <View>
                    <Heading level={4}>Manually Add Schedule</Heading>
                    {manualSchedule.map((schedule, index) => (
                      <View key={index} style={{ borderBottom: "1px solid #ccc", marginBottom: "1rem", paddingBottom: "1rem" }}>
                        <Text>Reservation #{index + 1}</Text>
                        <input
                          type="text"
                          placeholder="VIN"
                          value={schedule.vin}
                          onChange={(e) => handleScheduleChange(index, 'vin', e.target.value)}
                          style={{ marginRight: "10px" }}
                        />
                        <input
                          type="text"
                          placeholder="License Plate"
                          value={schedule.licenseNumber}
                          onChange={(e) => handleScheduleChange(index, 'licenseNumber', e.target.value)}
                          style={{ marginRight: "10px" }}
                        />
                        <input
                          type="text"
                          placeholder="License Plate State"
                          value={schedule.licenseState}
                          onChange={(e) => handleScheduleChange(index, 'licenseState', e.target.value)}
                          style={{ marginRight: "10px" }}
                        />
                        <input
                          type="text"
                          placeholder="Driver Name"
                          value={schedule.licenseNumber}
                          onChange={(e) => handleScheduleChange(index, 'driverName', e.target.value)}
                          style={{ marginRight: "10px" }}
                        />
                        <input
                          type="text"
                          placeholder="Driver License"
                          value={schedule.licenseNumber}
                          onChange={(e) => handleScheduleChange(index, 'driverLicense', e.target.value)}
                          style={{ marginRight: "10px" }}
                        />
                        <input
                          type="text"
                          placeholder="Driver License State"
                          value={schedule.licenseNumber}
                          onChange={(e) => handleScheduleChange(index, 'driverLicenseState', e.target.value)}
                          style={{ marginRight: "10px" }}
                        />
                        <input
                          type="text"
                          placeholder="Driver Email"
                          value={schedule.licenseNumber}
                          onChange={(e) => handleScheduleChange(index, 'driverEmail', e.target.value)}
                          style={{ marginRight: "10px" }}
                        />


                        <br/>
                        <br/>
                        <Flex direction="row" wrap="wrap" justifyContent="flex-start" gap="1rem">
                          <Text>Reservation Start:</Text>
                          <DatePicker
                                name="Reservation Start"
                                selected={schedule.resStart}
                                onChange={(date) => handleScheduleChange(index, 'resStart', date)}
                                showTimeSelect
                                dateFormat="MMMM d, yyyy h:mm aa"
                                timeIntervals={60}
                              />
                        </Flex>
                        <br/>
                        <Flex direction="row" wrap="wrap" justifyContent="flex-start" gap="1rem">
                          <Text>Reservation End:</Text>
                          <DatePicker
                                name="Reservation End"
                                selected={schedule.resEnd}
                                onChange={(date) => handleScheduleChange(index, 'resEnd', date)}
                                showTimeSelect
                                dateFormat="MMMM d, yyyy h:mm aa"
                                timeIntervals={60}
                              />
                        </Flex>
                        <br/>
                        <br/>

                
                        {manualSchedule.length > 1 && (
                          <Button variation="link" onClick={() => removeScheduleRow(index)}>Remove</Button>
                        )}
                      </View>
                    ))}
                    <Button onClick={addScheduleRow}>+ Add Another Reservation</Button>
                    <br /><br />
                    <Button onClick={submitManualSchedule}>SUBMIT</Button>
                    <br /><br />
                    <Button onClick={() => resetPage()}>CANCEL</Button>
                  </View>
                  : showDriverOptions ?
                    <View>
                      <Heading level={4}>Choose Method</Heading>
                      <br/>
                      <Button onClick={() => showUploadBulkDrivers()}>UPLOAD BULK DRIVERS</Button>
                      <br/>
                      <br/>
                      <Button onClick={() => updateShowEnterDriversManually(true)}>MANUALLY ENTER DRIVERS</Button>
                      <br />
                      <br />
                      <br />
                      <Button onClick={() => resetPage()}>CANCEL</Button>
                    </View>
                  : showScheduleOptions ?
                    <View>
                      <Heading level={4}>Choose Method</Heading>
                      <br/>
                      <Button onClick={() => showUploadBulkSchedule()}>UPLOAD BULK SCHEDULE</Button>
                      <br/>
                      <br/>
                      {
                        1==2 ? 
                          <Button onClick={() => updateShowEnterScheduleManually(true)}>MANUALLY ENTER SCHEDULE</Button>
                        : 
                          <Button backgroundColor={'#9E9E9E'}>MANUALLY ENTER SCHEDULE</Button>
                      }
                      <br />
                      <br />
                      <br />
                      <Button onClick={() => resetPage()}>CANCEL</Button>
                    </View>
                  : 
                    <View>
                      <Heading level={4}>Add Drivers or Schedule</Heading>
                      <br/>
                      <Button onClick={() => updateShowDriverOptions(true)}>ADD DRIVERS</Button>
                      <br/>
                      <br/>
                      <Button onClick={() => updateShowScheduleOptions(true)}>ADD SCHEDULE</Button>
                    </View>
                }
            </Flex>
          </Flex>
        </View>
      </Flex>
  );
}